<template>
    <div id="header-outer" class="header-outer">
        <header id="site-header" class="site-header">
            <div class="container flex">
                <LogoButton></LogoButton>
                <nav-button @menu-toggle="toggleNav" />
            </div>
            <the-nav-menu :navOpen="navOpen"></the-nav-menu>
        </header>
    </div>
</template>

<script lang="js">
    import NavButton from '../nav/NavButton.vue'
    import TheNavMenu from '../nav/TheNavMenu.vue'
    import LogoButton from './LogoButton.vue'

    export default {
        name: "the-header",
        components: {
            NavButton,
            TheNavMenu,
            LogoButton
        },
        data() {
            return {
                navOpen: false
            }
        },
        methods: {
            toggleNav: function (v) {
                this.navOpen = v;
            }
        }
    };
</script>

<style>
    .site-header {
        z-index: 1;
        width: 100%;
        -moz-transition: z-index 1s;
        -o-transition: z-index 1s;
        -webkit-transition: z-index 1s;
        transition: z-index 1s;
    }

        .site-header div.flex {
            align-items: center;
            padding: 0.85rem 1.5rem 0.85rem 1.5rem;
            position: relative;
            z-index: 3;
            max-width: 100%;
        }

    body.menu-open .site-header {
        z-index: 3;
        -moz-transition: none;
        -o-transition: none;
        -webkit-transition: none;
        transition: none;
    }

    @media screen and (min-width: 800px) {
        .site-header div.flex {
            border-bottom: solid 1px var(--black2);
        }
    }
</style>